/**
 * Identificadores que apontam para UM registro: documento do cliente, código do pedido e
 * identificador próprio do lojista.
 */
type ExactIdentifiers = {
  customerDocument?: string
  code?: string
  ownId?: string
}

/**
 * Indica se a busca foi feita por um identificador exato.
 *
 * Quando o operador tem o CPF, o código do pedido ou o identificador próprio, ele quer AQUELE
 * registro — e não sabe de que data ele é. Obrigar a escolher um período nesse caso inviabiliza
 * a busca: quem procura um pedido de três meses atrás precisaria adivinhar a semana certa antes
 * de encontrá-lo.
 *
 * Com identificador exato o recorte por data sai da consulta. Sem ele, o período continua
 * obrigatório — é o que impede a listagem de varrer a base inteira.
 *
 * @param identifiers Campos de busca exata do formulário.
 * @returns `true` quando ao menos um identificador foi preenchido.
 */
export const hasExactIdentifier = ({
  customerDocument,
  code,
  ownId,
}: ExactIdentifiers): boolean =>
  Boolean(customerDocument?.trim()) ||
  Boolean(code?.trim()) ||
  Boolean(ownId?.trim())
